import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdate() {
  const latestComics = getLatestComics(8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            <i className="ri-timer-line text-secondary-500 mr-2"></i>
            最新更新
          </h2>
          <Link
            to="/category/rexue"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}